import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-indoor-game-room',
  templateUrl: './indoor-game-room.component.html',
  styleUrls: ['./indoor-game-room.component.scss']
})
export class IndoorGameRoomComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
